import {CampaignsService_GetDiscounts} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.grpc';
import {useGrpcRequest, useGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {useOptionalSession} from '@aboutyou/user';
import {
  useTargetGroupIdentifier,
  useTargetGroupIdentifierCallback,
} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCallback} from 'react';

export const useDiscounts = (
  {disabled}: {disabled?: boolean} = {disabled: false},
) => {
  const session = useOptionalSession();
  const targetGroup = useTargetGroupIdentifier();
  const discountResponse = useGrpcRequest(
    CampaignsService_GetDiscounts,
    {
      session,
      targetGroup,
    },
    {
      // The campaign data is cached for 2.5 minutes, so polling every half that amount ensures we pick up updates
      refetchInterval: TWO_MINUTES_THIRTY_SECONDS,
      refetchOnWindowFocus: true,
      staleTime: TWO_MINUTES_THIRTY_SECONDS,
      nonEssential: true,
      disabled, // disable call if feature is not active. Mostly here because of basket
    },
  );

  return discountResponse;
};

export const useDiscountsCallback = () => {
  const queryFn = useGrpcRequestCallback(CampaignsService_GetDiscounts);
  const getTargetGroup = useTargetGroupIdentifierCallback();
  const session = useOptionalSession();

  return useCallback(() => {
    const targetGroup = getTargetGroup();
    return queryFn({session, targetGroup});
  }, [queryFn, session, getTargetGroup]);
};

const TWO_MINUTES_THIRTY_SECONDS = 2.5 * 60 * 1000;
